// extracted by mini-css-extract-plugin
export default {"disconnect-successful-form":"wZNbhT","disconnectSuccessfulForm":"wZNbhT"};